import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.ITEMS,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'HISTORY'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/items/get/history.js